import 'rxjs/add/observable/throw';

import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { DateUtils } from '../../shared/_utils/services/dateUtils';
import { FiscalYear } from '../entities/fiscalYear';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class FiscalYearService extends BaseCrudService<FiscalYear> {

    public uri = '/api/fiscalYear/';
    private currentFiscalYear: FiscalYear;

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance FiscalYearService');
        this.findCurrentFiscalYear();
    }

    private findCurrentFiscalYear() {
        this.getOneByCode(DateUtils.getCurrentYear()).subscribe((resp) => this.currentFiscalYear = resp);
    }

    getCurrentFiscalYear() {
        return this.currentFiscalYear;
    }

    buildSentence(entity?: FiscalYear, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code'
                + QueryOperator.Contain + entity.code
                + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                + QueryOperator.Contain + entity.name
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.startDate ? 'startDate'
                + QueryOperator.Equal + entity.startDate
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.endDate ? 'endDate'
                + QueryOperator.Equal + entity.endDate
                + QueryOperator.Split : QueryOperator.Empty
            );
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/fiscal-year.service.ts